import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export interface UserData {
  rrn: string;
  firstname: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  userData = new BehaviorSubject<UserData>(undefined);
  userData$ = this.userData.asObservable();

  constructor() {
  }

  saveUserData(data: UserData): void {
    if (window.sessionStorage.getItem('user')){
      window.sessionStorage.removeItem('user');
    }
    window.sessionStorage.setItem('user', JSON.stringify(data));
    this.userData.next(data);
  }
}
